/**
 * @module helpers/assetHelper
 */

/**
 * generate asset url based on env
 *
 * @example
 * assetURL('icons/auto_invest_emas.png')
 * // -> "http://www.local.host:2430/icons/auto_invest_emas.png"
 *
 * @param src {String} relative url from public folder
 * @return {String} absolute url for certain assets
 */

const placeholderImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';

export function assetURL(src, isSSR = false) {
  if (isSSR) {
    return placeholderImage;
  }

  const url = new URL(process.env.PUBLIC_PATH + src, process.env.ASSET_URL);
  return url.href;
}

export function imageryURL(src, size = 'original') {
  if (process.env.NODE_ENV === 'development') {
    return src;
  }

  return src.replace('/original/', `/${size}/`);
}

export function getExtension(src) {
  return src.split('.').pop();
}

export function getMime(src) {
  const ext = getExtension(src);

  if (['jpg', 'jpeg'].includes(ext)) {
    return 'image/jpeg';
  }

  return `image/${ext}`;
}

export default {
  assetURL,
};
